import React, { forwardRef } from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-61">
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-62">
          {label}
        </label>
        <input id={inputId} ref={ref} className={`w-full px-3 py-2.5 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-green-600 transition-colors ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300'} ${className}`} {...props} data-id="element-63" />
        {error && <p className="mt-1.5 text-sm text-red-600 font-medium" data-id="element-64">{error}</p>}
      </div>;
});
Input.displayName = 'Input';